import React, { useState, useEffect } from 'react'

import { useDispatch, useSelector } from 'react-redux'
import { Link, useHistory } from 'react-router-dom'
import styled from 'styled-components'

import { toggleMenu, listMenu } from '../../_actions'
import { useWindowSize } from '../../_helpers'
import {
    Image,
    UnstyledLink,
    devices,
    colors,
    UpperHeader,
} from '../Common'


const NavigationItem = ({ toggle, header, links, open, closeMenu, URL }) => (
    <NavItem>
        <NavItemHeader
            as={links.length === 0 ? Link : ''}
            to={links.length === 0 ? URL : ''}
            onClick={links.length === 0 ? closeMenu(URL) : toggle}
        >
            {header}
        </NavItemHeader>
        {links.length > 0 ? (
            <NavItemContent open={open}>
                {links.map(item =>
                    <NavItemContentItem key={item.title}>
                        <UnstyledLink
                            as={Link}
                            to={item.linked_page}
                            onClick={closeMenu(item.linked_page)}
                        >
                            {item.title}
                        </UnstyledLink>
                    </NavItemContentItem>
                )}
            </NavItemContent>
        ) : ''}
    </NavItem>
)

export const Nav = () => {
    const dispatch = useDispatch()
    const history = useHistory()
    const { menu, menuOpen } = useSelector(state => state.content)
    const { width } = useWindowSize()
    const mobile = width < 480

    const [openNavItem, setOpenNavItem] = useState('')
    const [activeMenu, setActiveMenu] = useState(menu)

    useEffect(() => {
        dispatch(listMenu())
        setActiveMenu(menu)
    }, [])

    const changeLocation = location => e => {
        e.preventDefault()
        if (!location) return
        if (location !== history.location.pathname) {
            history.push(location)
        }
        dispatch(toggleMenu(false))
        document.body.style.overflow = 'visible'
    }

    const openMenuPanel = () => {
        dispatch(toggleMenu(!menuOpen))
        document.body.style.overflow = menuOpen ? 'visible' : 'hidden'
    }

    const toggleNavItem = title => () => setOpenNavItem(title === openNavItem ? '' : title)

    // close individual menuItem
    const closeMenu = location => e => {
        dispatch(toggleMenu(false))
        document.body.style.overflow = 'visible'
        setOpenNavItem('')
        if (!location || e.metaKey) return
    }

    // Hide the entire side menu
    const closePanel = () => {
        dispatch(toggleMenu(false))
        setOpenNavItem('')
        document.body.style.overflow = 'visible'
    }

    return (
        <NavigationWrap open={menuOpen}>
            <div>
                <MenuButton role='button' open={menuOpen} onClick={openMenuPanel}>
                    <div>
                        <div />
                        <div />
                        <div />
                    </div>
                </MenuButton>
            </div>
            <Menu>
                <div>
                    <CloseButton role='button' aria-label='Close Menu' onClick={closePanel} />
                    {/* prev button goes here */}
                </div>
                <MenuTitle>Menu</MenuTitle>
                {menu.map(link =>
                    <NavigationItem
                        key={link.title}
                        header={link.title}
                        changeLocation={changeLocation}
                        closeMenu={closeMenu}
                        toggle={toggleNavItem(link.title)}
                        open={openNavItem === link.title}
                        links={link.children}
                        URL={link.linked_page}
                    />
                )}
            </Menu>
        </NavigationWrap>
    )
}

// const MobileControls = styled.div`
//     height: 65px;
//     position: relative;
//     display: flex;
//     align-items: center;
//     justify-content: space-between;
//     ${({ alert }) => alert && 'margin-top: 75px;'}
// `

// const MobileLogo = styled.div`
//     background: url('/static/images/sprite.svg') no-repeat -220px -210px;
//     width: 223px;
//     height: 30px;
// `

const CloseButton = styled.div`
    width: 40px;
    height: 40px;
    background: url('/static/images/sprite.svg') no-repeat  -79px -78px;
    border: 1px solid ${colors.white};
    border-radius: 50%;
    /* padding: 10px; */
    margin-bottom: 10px;
    cursor: pointer;
`

const NavItem = styled.div`
    position: relative;
    /* margin-bottom: 20px; */
    display: flex;
    flex-direction: column;
    @media ${devices.small} {
        margin-bottom: 0;
        padding-bottom: 20px;
    }
`

const NavigationWrap = styled.nav`
    display: flex;
    flex-direction: row;
    background: ${colors.red};
    height: 100vh;
    width: calc(50vw + 50px);
    /* cursor: pointer; */
    position: fixed;
    left: 0;
    flex: 1;
    z-index: 0;
    padding: 4vh 2vw;
    background: ${colors.pink};
    color: ${colors.white};

    @media ${devices.small} {
    }
`

const Menu = styled.div`
    /* max-height: 100vh; */
    padding: 0 40px;
    overflow-x: hidden;

    ${NavItem} {
        width: 100%;
    }

    @media (max-width: 1450px) {
        /* padding-left: 0;
        padding-right: 0; */
    }

    @media ${devices.small} {
        padding: 30px 0 0 0;
        margin-bottom: auto;
    }
`

const NavItemHeader = styled.div`
    font-size: 42px;
    // font-family: '';
    cursor: pointer;
    line-height: 48px;
    display: inline-flex;
    text-decoration: none;
    flex-direction: column;
    color: ${colors.white};

    img {
        /* position: absolute !important; */
        left: 0px;
        top: 7px;
    }

    div {
        display: inline;
    }

    @media ${devices.tablet} {
        font-size: 28px;
    }

    @media ${devices.small} {
        font-size: 45px;
        padding-left: 0;
        ${Image} {
            height: 15px;
            top: 9px;
        }
    }
`

const NavItemContent = styled.div`
    display: ${({ open }) => open ? 'block' : 'none'};
    float: left;
    max-width: 670px;
    padding-left: 42px;

    @media ${devices.small} {
        padding-left: 0;
    }
`

const NavItemContentItem = styled.div`
    display: inline-block;
    width: 100%;
    font-weight: bold;

    @media ${devices.small} {
        margin-bottom: 10px;
        padding-left: 30px;
    }
`

const MenuButton = styled.div`
    display: flex;
    height: 32px;
    padding: 1px 0 0;
    cursor: pointer;
    // font-family: '';
    font-size: 38px;
    line-height: 1;
    color: ${colors.white};
    ${({ small }) => small ? 'margin-top: -17px;' : ''}

    > div {
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 35px;
        height: 35px;

        > div {
            height: 3px;
            margin: 3px 0;
            background: ${colors.white};
        }
    }

    @media ${devices.small} {
        height: 21px;

        > div {
            height: 21px;
        }
    }
`

const MenuTitle = styled(UpperHeader)`
`